"use strict";
import React, {Component} from "react";
import EditTemplateLess from "./EditTemplate.less";
import {PropTypes, RenderContent} from "Subschema";

export default class EditTemplate extends Component {
    static propTypes = {
        buttons: PropTypes.node,
        legend: PropTypes.node,
        className: PropTypes.cssClass,
        field: PropTypes.any,
        content: PropTypes.node,
        onCheckChange: PropTypes.valueEvent,
        checked: PropTypes.value,
        editText: PropTypes.string,
        viewContent: PropTypes.content,
        path: PropTypes.path,
        isEditMode: PropTypes.value
    };
    static defaultProps = {
        onCheckChange: "_internal.edit",
        checked: "_internal.edit"
    };

    handleChange = (e)=> {
        this.props.onCheckChange(!e.target.checked);
    };

    render() {
        let {checked, isEditMode, editText} = this.props;
        const show = editText && !checked;
        return <div className={EditTemplateLess.container}>
            {show ? <label className={EditTemplateLess.link}>
                <input type="checkbox" name={this.props.path+'_internal.edit'}
                       checked={!this.props.checked}
                       onChange={this.handleChange}/>
                {editText}
            </label> : null }
            <div className={EditTemplateLess.legend}>
                {this.props.legend}
            </div>
            <div className={EditTemplateLess.content}>
                {this.props.content}
            </div>
            <div className={EditTemplateLess.fields}>
                {this.props.children}
            </div>
        </div>
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/EditTemplate.jsx
 **/